export default __webpack_public_path__ + "static/media/plp-photo-grid-icon.17258424.svg";